import(/* webpackMode: "eager", webpackExports: ["AboutContent"] */ "/vercel/path0/src/components/about/AboutContent.tsx");
